import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;

// 首页
export const getIndexDataV2 = (params={}) => {
    const url = adminApi  + 'v2/common/indexData'
    return http.fetchGet(url, params);
}
//我的车型测评
export const getReportIndexDataV2 = (params={}) => {
    const url = adminApi  + 'v2/report/index'
    return http.fetchGet(url, params);
}
//我的车型评测 推荐车型
export const getRecommendCarV2 = (params={}) => {
    const url = adminApi  + 'v2/report/recommend'
    return http.fetchGet(url, params);
}
//排行榜
export const getRankDataV2 = (params={}) => {
    const url = adminApi  + 'v2/report/rank'
    return http.fetchGet(url, params);
}
export const getRankNodeDataV2 = (params={}) => {
    const url = adminApi  + 'v2/report/rankNode'
    return http.fetchGet(url, params);
}
// 车型综述
export const getCarSummaryDataV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/detail'
    return http.fetchGet(url, params);
}
export const getCampSummaryDataV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/campDetail'
    return http.fetchGet(url, params);
}
//指标得分(性能,功能,旅途)
export const getCarScoreV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/node'
    return http.fetchPost(url, params);
}
export const getCampScoreV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/campNode'
    return http.fetchPost(url, params);
}
//指标得分(创新)
export const getCarScoreInnovateV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/innovateNode'
    return http.fetchPost(url, params);
}
//获取节点测评详情
export const getTestDetailV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/nodeDetail'
    return http.fetchPost(url, params);
}
//获取创新指标详情
export const getInnovateDetailV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/innovateNodeDetail'
    return http.fetchPost(url, params);
}
//获取创新标杆分析
export const getInnovateLineDetailV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/innovateAnalysisData'
    return http.fetchPost(url, params);
}
//获取一级标杆分析
export const getNodeLineDetailV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/functionAnalysisData'
    return http.fetchPost(url, params);
}
//获取二级标杆分析
export const getNodeLineTwoDetailV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/functionAnalysisDetail'
    return http.fetchPost(url, params);
}
//获取二级标杆
//添加竞品车型
export const addCompareCarV2 = (params={}) => {
    const url = adminApi  + 'v2/report/user/addCompareCar'
    return http.fetchPost(url, params);
}
//删除竞品车型
export const delCompareCarV2 = (params={}) => {
    const url = adminApi  + 'v2/report/user/delCompareCar'
    return http.fetchPost(url, params);
}
//获取竞品车型列表
export const getCompareCarListV2 = (params={}) => {
    const url = adminApi  + 'v2/report/user/compareCarList'
    return http.fetchPost(url, params);
}
//更换首页的车型
export const changeUserCarV2 = (params={}) => {
    const url = adminApi  + 'v2/report/user/updatePersonalizationCar'
    return http.fetchPost(url, params);
}
//搜索叶子节点
export const searchNodeV2 = (params={}) => {
    const url = adminApi  + 'v2/report/search/node'
    return http.fetchPost(url, params);
}

//核心场景分析页面 二级节点列表
export const getParentNodesV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/coreScene/tree'
    return http.fetchPost(url, params);
}
//核心场景分析页面 二级节点列表
export const getNodeVideosV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/coreScene/videos'
    return http.fetchPost(url, params);
}

//添加收藏车型
export const addCollectV2 = (params={}) => {
    const url = adminApi  + 'v2/report/user/addCollect'
    return http.fetchPost(url, params);
}
//删除收藏车型
export const delCollectV2 = (params={}) => {
    const url = adminApi  + 'v2/report/user/delCollect'
    return http.fetchPost(url, params);
}

// 智能搜索车型列表
export const getSearchModelV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/permissionInfo'
    return http.fetchPost(url, params);
}
// 智能搜索结果
// ?model_id=&keyword=
export const getSearchResoultV2 = (params={}) => {
    const url = adminApi  + 'v2/report/search/nodeCompare'
    return http.fetchPost(url, params);
}

// 搜索车型
export const getSearchCarV2 = (params={}) => {
    const url = adminApi  + 'v2/report/search/car'
    return http.fetchPost(url, params);
}
// 搜索车型-创新
export const getSearchResoultCxV2 = (params={}) => {
    const url = adminApi  + 'v2/report/search/innovateNodeCompare'
    return http.fetchPost(url, params);
}



//获取 车型库 筛选配置
export const getCarFilterConfigV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/filterConfig'
    return http.fetchGet(url, params);
}
//获取车型库 筛选结果 更换车型 
export const getCarLibraryV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car'
    return http.fetchGet(url, params);
}


//获取我的车型
export const getMyCarV2 = (params={}) => {
    const url = adminApi  + 'v2/report/user/personalizationCarList'
    return http.fetchPost(url, params);
}


//获取节点树
export const getNodeV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/coreScene/tree'
    return http.fetchGet(url, params);
}

//获取节点详情
export const getNodeDetailV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/coreScene/video'
    return http.fetchGet(url, params);
}

//获取相关视频
export const getRelaVideoV2 = (params={}) => {
    const url = adminApi  + 'v2/report/car/coreScene/relateVideo'
    return http.fetchGet(url, params);
}
